import React from "react";
import { getYoutubeEmbedUrl } from "../lib/youtube";

export function getCompanyVideoEmbedUrl(introductionUrl) {
  return getYoutubeEmbedUrl(introductionUrl);
}

export default function CompanyVideoEmbed({ introductionUrl, className = "" }) {
  const embedUrl = getCompanyVideoEmbedUrl(introductionUrl);

  if (!embedUrl) return null;

  return (
    <div
      className={`overflow-hidden rounded-xl border border-slate-200 bg-slate-900 shadow-lg ${className}`}
    >
      <div className="relative aspect-video w-full">
        <iframe
          src={embedUrl}
          title="SSA Techno introduction video"
          className="absolute inset-0 h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </div>
  );
}
